import { Building2, FileCheck2, FlaskConical, ShieldPlus, HeartHandshake, Stethoscope } from "lucide-react";

export const SERVICES = [
  { id: "hospital-admissions", title: "Hospital Admissions", tag: "01", icon: Building2, img: "/images/hospital.jpg",
    text: "Planned or emergency, we shortlist suitable hospitals, compare estimates, reserve the bed and walk you through admission paperwork.",
    span: "lg:col-span-2 lg:row-span-2" },
  { id: "claims-assistance", title: "Claims Assistance", tag: "02", icon: FileCheck2, img: "/images/claims.jpg",
    text: "Cashless approvals, reimbursement files and insurer follow-ups handled by specialists who know the process.", span: "lg:col-span-2" },
  { id: "diagnostics", title: "Diagnostics", tag: "03", icon: FlaskConical, img: "/images/lab.jpg",
    text: "Lab tests and scans at partner centres or from home.", span: "lg:col-span-1" },
  { id: "preventive-health", title: "Preventive Health", tag: "04", icon: ShieldPlus, img: "/images/preventive.jpg",
    text: "Check-up packages that catch risks early.", span: "lg:col-span-1" },
  { id: "home-care", title: "Home Care", tag: "05", icon: HeartHandshake, img: "/images/nursing.jpg",
    text: "Nursing, physiotherapy and elder support arranged at your residence after discharge or for long-term needs.", span: "lg:col-span-2" },
  { id: "doctor-consultations", title: "Doctor Consultations", tag: "06", icon: Stethoscope, img: "/images/tele.jpg",
    text: "In-clinic or video appointments with specialists matched to the condition, plus prescription delivery.", span: "lg:col-span-2" },
];

export const JOIN = [
  { type: "franchise", label: "Franchise Enrolment", short: "Franchise", img: "/images/doctor2.jpg", menu: "Run a regional IMG Health desk",
    blurb: "Operate an IMG Health care desk in your territory with our brand, marketing support and provider network behind you." },
  { type: "partner", label: "Partner Enrolment", short: "Partner", img: "/images/admission.jpg", menu: "For hospitals, labs, insurers & doctors",
    blurb: "Hospitals, labs, insurers, TPAs and clinicians receive qualified patient referrals through our platform." },
  { type: "vendor", label: "Vendor Enrolment", short: "Vendor", img: "/images/pharmacy.jpg", menu: "For suppliers & service firms",
    blurb: "List your medical equipment, consumables, pharmacy or technology services with our partner ecosystem." },
];

export const FORMS = {
  franchise: {
    title: "Franchise Enrolment",
    kicker: "Own a territory",
    intro: "Bring aggregated healthcare access to your city. Share a few details and our franchise development team will reach out with the next steps.",
    orgLabel: "Current business (if any)",
    orgRequired: false,
    fields: [
      { key: "investment_capacity", label: "Investment capacity", options: ["Under ₹10 Lakh", "₹10–25 Lakh", "₹25–50 Lakh", "Above ₹50 Lakh"] },
      { key: "preferred_location", label: "Preferred franchise location", placeholder: "Area / locality" },
      { key: "experience", label: "Healthcare experience", options: ["None", "1–3 years", "3–7 years", "7+ years"] },
    ],
  },
  partner: {
    title: "Partner Enrolment",
    kicker: "Provider network",
    intro: "Diagnostic centres, nursing agencies, insurance companies and independent doctors can list with us to start receiving patient enquiries.",
    orgLabel: "Organisation name",
    orgRequired: true,
    fields: [
      { key: "partner_type", label: "Partner type", options: ["Hospital", "Clinic", "Diagnostic Lab", "Insurance / TPA", "Nursing Agency", "Doctor / Specialist", "Physiotherapist", "Other"] },
      { key: "operating_regions", label: "Operating regions", placeholder: "Cities / districts you serve" },
      { key: "website", label: "Website (optional)", placeholder: "https://", optional: true },
    ],
  },
  vendor: {
    title: "Vendor Enrolment",
    kicker: "Supplier network",
    intro: "Equipment makers, pharma distributors, consumable suppliers and health-tech firms can register to serve our partner facilities.",
    orgLabel: "Company name",
    orgRequired: true,
    fields: [
      { key: "product_category", label: "Product category", options: ["Medical Equipment", "Pharmaceuticals", "Consumables", "Diagnostic Kits", "Healthcare IT", "Other"] },
      { key: "gst_number", label: "GST number", placeholder: "e.g. 22AAAAA0000A1Z5" },
      { key: "years_in_business", label: "Years in business", options: ["Under 1", "1–3", "3–10", "10+"] },
    ],
  },
};

export const CONTACT = [
  { id: "patients", label: "For Patients", value: "+91 940 389 1300", href: "tel:+919403891300" },
  { id: "hospitals", label: "For Hospitals", value: "+91 9971 97 2300", href: "tel:+919971972300" },
  { id: "email", label: "Email", value: "info@imghealth.in", href: "mailto:info@imghealth.in" },
];
